import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import SlicesInput from './SlicesInput';

const splitText = (text) => text.match(/\S+/g) || [];

export default class SlicesInputContainer extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onSplit: PropTypes.func,
    text: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(
      PropTypes.shape({
        index: PropTypes.number,
        text: PropTypes.string,
        correct: PropTypes.bool,
      })
    ),
    label: PropTypes.string,
    maxRemovesAllowed: PropTypes.number,
    errorText: PropTypes.string,
    sequenceRemove: PropTypes.bool,
    allowLinkSlices: PropTypes.bool,
    showPreview: PropTypes.bool,
    disabled: PropTypes.bool,
    isCorrect: PropTypes.bool,
    color: PropTypes.string,
  };

  static defaultProps = {
    maxRemovesAllowed: null,
    errorText: null,
    value: [],
    label: 'Here you must click on the X button to select the word(s) to hide',
    sequenceRemove: false,
    allowLinkSlices: false,
    showPreview: true,
    disabled: false,
    onSplit: splitText,
    isCorrect: true,
  };

  state = { slices: [], removedSlices: [] };

  componentWillMount() {
    if (this.props.text.length > 0) {
      this.setState({
        slices: this.props.onSplit(this.props.text),
        removedSlices: this.props.value,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.text.length > 0) {
      this.setState({
        slices: nextProps.onSplit(nextProps.text),
      });
    } else {
      this.setState({ slices: [] });
    }
    if (nextProps.value) {
      this.setState({
        removedSlices: nextProps.value,
      });
    }
  }

  handleRemoveSlice = (index) => {
    let updatedRemovedSlices = sortBy(
      [
        ...this.state.removedSlices.filter((slice) => slice.index !== index),
        {
          index,
          id: new Date().toISOString(),
          text: this.state.slices[index],
          correct: this.props.isCorrect,
        },
      ],
      'index'
    );

    if (this.props.sequenceRemove) {
      updatedRemovedSlices = updatedRemovedSlices.map((slice) => {
        return {
          ...slice,
          linkTo: slice.index + 1,
        };
      });
    }

    this.setState(
      {
        removedSlices: updatedRemovedSlices,
      },
      () => {
        this.props.onChange(this.state.removedSlices);
      }
    );

    return updatedRemovedSlices;
  };

  handleShowSlice = (index) => {
    let updatedRemovedSlices = this.state.removedSlices.filter((slice) => slice.index !== index);
    updatedRemovedSlices = updatedRemovedSlices.map((slice) => {
      if (slice.linkTo === index) {
        return {
          ...slice,
          linkTo: null,
        };
      }
      return slice;
    });
    this.setState(
      {
        removedSlices: updatedRemovedSlices,
      },
      () => {
        this.props.onChange(this.state.removedSlices);
      }
    );
  };

  handleLinkSlice = (index) => {
    let removedSlices = this.state.removedSlices;

    if (!this.state.removedSlices.find((slice) => slice.index === index)) {
      removedSlices = this.handleRemoveSlice(index);
    }

    if (!removedSlices.find((slice) => slice.index === index + 1)) {
      removedSlices = this.handleRemoveSlice(index + 1);
    }

    const updatedRemovedSlices = removedSlices.map((slice) => {
      if (slice.index === index) {
        return {
          ...slice,
          linkTo: index + 1,
        };
      }
      return slice;
    });
    this.setState(
      {
        removedSlices: updatedRemovedSlices,
      },
      () => {
        this.props.onChange(this.state.removedSlices);
      }
    );
  };

  render() {
    return (
      <SlicesInput
        onRemoveSlice={this.handleRemoveSlice}
        onShowSlice={this.handleShowSlice}
        onLinkSlice={this.handleLinkSlice}
        removedSlices={this.state.removedSlices.filter((slice) => slice.hasOwnProperty('index'))}
        slices={this.state.slices}
        label={this.props.label}
        disableRemove={
          this.state.removedSlices.filter((slice) => slice.hasOwnProperty('index')).length ===
          this.props.maxRemovesAllowed
        }
        errorText={this.props.errorText}
        sequenceRemove={this.props.sequenceRemove}
        allowLink={this.props.allowLinkSlices}
        showPreview={this.props.showPreview}
        disabled={this.props.disabled}
        color={this.props.color}
      />
    );
  }
}
